import ObjectScreen from '@components/v2/layout/ObjectScreen/ObjectScreen';
import { Stack } from '@mui/material';
import { OrderConditionsTestIds } from '../../../../../../../../utils/testIds/OrderConditions.testIds';
import { useTranslation } from '../../../../../../../translation/TranslationContext';
import {
  getConditionAvailability,
  getConditionSplitLabelParts,
} from '../../../../../../conditions/orderCondition.utils';
import OrderSplitTreeAllItem from './components/OrderSplitTreeAllItem';
import OrderSplitTreeItem from './components/OrderSplitTreeItem';
import useOrderObjectSplitsSection from './hooks/useOrderObjectSplitsSection';

const OrderObjectSplitsSection = () => {
  const { translate } = useTranslation();
  const {
    groupLabel,
    title,
    isConditionsTab,
    isAllConditionsSelected,
    isAllSelected,
    highlightedConditionId,
    listedConditions,
    hasConditionError,
    selectAllConditions,
    selectCondition,
  } = useOrderObjectSplitsSection();

  return (
    <ObjectScreen.Section title={title} persistKey="order:splits" isDefaultOpen>
      <Stack role="group" aria-label={groupLabel} sx={{ gap: 0.5 }}>
        <OrderSplitTreeAllItem
          isSelected={isAllSelected}
          isPressed={isAllConditionsSelected}
          isDisabled={isConditionsTab}
          onSelect={selectAllConditions}
        />

        {listedConditions.map((condition, index) => (
          <OrderSplitTreeItem
            key={condition.id}
            {...getConditionSplitLabelParts(condition, translate)}
            availability={getConditionAvailability(condition.orderType)}
            isSelected={condition.id === highlightedConditionId}
            isLastChild={index === listedConditions.length - 1}
            hasErrors={hasConditionError(condition.id)}
            testId={`${OrderConditionsTestIds.SPLIT_TREE_ITEM}-${condition.id}`}
            onSelect={() => selectCondition(condition.id)}
          />
        ))}
      </Stack>
    </ObjectScreen.Section>
  );
};

export default OrderObjectSplitsSection;
